import React, { useState, useEffect, useMemo } from "react";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { pega_pedidos_carteirinhas, exportar_fotos, download_arquivo_gerado, pega_confere_carteirinhas } from "../../services/api";

const Carteirinhas_pedidos = (props) => {

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', '', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

    // Se props.un existir, já inicia os estados de unidade com ele. Caso contrário, string vazia.
    const [dataInicio, setDataInicio] = useState(props.di || '');
    const [dataFim, setDataFim] = useState(props.df || '');
    const [unidadeSelecionada, setUnidadeSelecionada] = useState(props.un || '');
    const [statusEntrega, setStatusEntrega] = useState('todos');

    const [filtroInicio, setFiltroInicio] = useState(props.di || '');
    const [filtroFim, setFiltroFim] = useState(props.df || '');
    const [filtroUnidade, setFiltroUnidade] = useState(props.un || '');
    const [filtroStatusEntrega, setFiltroStatusEntrega] = useState('todos');

    const [data26, setData26] = useState([]);
    const [dataConfere, setDataConfere] = useState([]);

    const convertSerie = (seg) => {
        switch (seg) {
            case '0-1': return 'MATERNAL I - Educação Infantil';
            case '0-2': return 'MATERNAL II - Educação Infantil';
            case '0-3': return 'PRÉ-ESCOLA I - Educação Infantil';
            case '0-4': return 'PRÉ-ESCOLA II - Educação Infantil';
            case '1-1': return '1º ANO - Anos Iniciais';
            case '1-2': return '2º ANO - Anos Iniciais';
            case '1-3': return '3º ANO - Anos Iniciais';
            case '1-4': return '4º ANO - Anos Iniciais';
            case '1-5': return '5º ANO - Anos Iniciais';
            case '1-6': return '6º ANO - Anos Finais';
            case '1-7': return '7º ANO - Anos Finais';
            case '1-8': return '8º ANO - Anos Finais';
            case '1-9': return '9º ANO - Anos Finais';
            case '2-1': return '1ª SÉRIE - Ensino Médio';
            case '2-2': return '2ª SÉRIE - Ensino Médio';
            case '7-3': return '3ª SÉRIE INT - Ensino Médio';
            default: return seg;
        }
    };

    const fetchData = async () => {
        try {
            const response = await pega_pedidos_carteirinhas();
            setData26(response);

            const confereResponse = await pega_confere_carteirinhas();
            setDataConfere(confereResponse);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handlePesquisar = () => {
        setFiltroInicio(dataInicio);
        setFiltroFim(dataFim);
        setFiltroUnidade(unidadeSelecionada);
        setFiltroStatusEntrega(statusEntrega);
    };

    const processedData = useMemo(() => {
        if (!data26 || data26.length === 0) return [];

        let chartData = data26
            .map((item) => {
                const confereItem = dataConfere.find(conf => conf.mat === item.matricula && conf.pedido === item.pedido.substring(0, 10));
                return {
                    ...item,
                    dataConferencia: (confereItem && confereItem.confere) ? confereItem.confere : ''
                };
            })
            .filter(item => {
                // Filtro de Datas
                if (filtroInicio && filtroFim) {
                    const dataPedido = new Date(item.pedido);
                    const dataI = new Date(filtroInicio);
                    const dataF = new Date(filtroFim);

                    dataPedido.setHours(0, 0, 0, 0);
                    dataI.setHours(0, 0, 0, 0);
                    dataF.setHours(0, 0, 0, 0);

                    if (dataPedido < dataI || dataPedido > dataF) return false;
                }

                // Trava de Segurança: Se props.un existir, restringe a essa unidade, ignorando o resto.
                if (props.un && parseInt(item.unidade) !== parseInt(props.un)) {
                    return false;
                }

                // Filtro do Select (Apenas se não for página de unidade específica)
                if (!props.un && filtroUnidade !== '') {
                    if (parseInt(item.unidade) !== parseInt(filtroUnidade)) return false;
                }

                // Filtro de Status (Não Entregues)
                if (filtroStatusEntrega === 'nao_entregues') {
                    if (item.dataConferencia !== '') return false;
                }

                return true;
            })
            .map((item) => {
                return [
                    unidades[parseInt(item.unidade)],
                    item.matricula,
                    item.nome,
                    item.nascimento,
                    item.turma,
                    convertSerie(item.turma.charAt(1) + '-' + item.turma.charAt(2)),
                    item.pedido,
                    item.soc,
                    item.dataConferencia
                ];
            });

        // Ordenação: 1º Unidade, 2º Turma, 3º Nome
        chartData.sort((a, b) => {
            if (a[0] !== b[0]) return a[0].localeCompare(b[0]);
            if (a[4] !== b[4]) return a[4].localeCompare(b[4]);
            return a[2].localeCompare(b[2]);
        });

        return chartData;
    }, [data26, dataConfere, filtroInicio, filtroFim, filtroUnidade, filtroStatusEntrega, props.un, unidades]);

    const headerRow = ['UNIDADE', 'MATRICULA', 'NOME', 'NASCIMENTO', 'TURMA', 'SÉRIE', 'DATA PEDIDO', 'NOME SOCIAL', 'DATA CONFERÊNCIA'];

    const handleExportCSV = () => {
        const dataToExport = [headerRow, ...processedData];
        const csvContent = "data:text/csv;charset=utf-8,"
            + dataToExport.map(row => {
                return row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(",");
            }).join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);

        const siglaExportacao = filtroUnidade !== '' ? unidades_sigla[parseInt(filtroUnidade)] : 'geral';
        const fileName = `pedidos_carteirinhas_${siglaExportacao}.csv`;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportFotos = async () => {
        if (processedData.length === 0) {
            alert("Nenhum aluno encontrado no filtro atual para exportar.");
            return;
        }

        const listaMatriculas = processedData.map(row => row[1]);
        const payload = { "arquivos": listaMatriculas };

        try {
            const response = await exportar_fotos(payload);
            const dadosRetorno = response.data || response;

            if (dadosRetorno.success) {
                if (dadosRetorno.data.totalCompactados > 0) {
                    const urlRelativa = dadosRetorno.data.downloadUrl;
                    const baseURL = "https://carteirinhas.smrede.net.br";
                    const urlCompleta = urlRelativa.startsWith('http') ? urlRelativa : `${baseURL}${urlRelativa}`;

                    const linkZip = document.createElement('a');
                    linkZip.href = urlCompleta;
                    linkZip.setAttribute('download', dadosRetorno.data.nomeArquivo);
                    linkZip.setAttribute('target', '_blank');
                    document.body.appendChild(linkZip);
                    linkZip.click();
                    document.body.removeChild(linkZip);
                }

                const erros = dadosRetorno.data.arquivosNaoEncontrados;

                if (erros && erros.length > 0) {
                    let conteudoTxt = "RELATÓRIO DE FOTOS NÃO ENCONTRADAS\n==================================\n\n";
                    conteudoTxt += `Total de erros: ${erros.length}\nData: ${new Date().toLocaleString()}\n\n`;
                    conteudoTxt += "MATRÍCULA    | MOTIVO\n----------------------------------\n";

                    erros.forEach(item => {
                        conteudoTxt += `${(item.nomeOriginal || "Desconhecida").padEnd(12)} | ${item.erro || "Não especificado"}\n`;
                    });

                    const blobTxt = new Blob([conteudoTxt], { type: 'text/plain' });
                    const urlTxt = window.URL.createObjectURL(blobTxt);
                    const linkTxt = document.createElement('a');
                    linkTxt.href = urlTxt;
                    linkTxt.setAttribute('download', 'relatorio_fotos_faltantes.txt');
                    document.body.appendChild(linkTxt);
                    linkTxt.click();
                    document.body.removeChild(linkTxt);
                    window.URL.revokeObjectURL(urlTxt);

                    alert(`Processo concluído!\n\n${dadosRetorno.data.totalCompactados} fotos baixadas.\n${erros.length} erros encontrados (veja o arquivo .txt baixado).`);
                } else {
                    alert(`Sucesso! Todas as ${dadosRetorno.data.totalCompactados} fotos foram encontradas e baixadas.`);
                }
            } else {
                alert("O servidor retornou erro: " + (dadosRetorno.message || "Erro desconhecido"));
            }
        } catch (error) {
            console.error("Erro no processo:", error);
            alert("Erro ao solicitar exportação.");
        }
    };

    return (
        <div className="pedidos mt-4">
            <center>
                <div>
                    <h4>Pedidos de Carteirinhas</h4>
                    <div style={{ maxWidth: '1100px', margin: '20px auto', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
                        <Form>
                            <Row className="mb-3 justify-content-center">
                                <Col md={3}>
                                    <Form.Group controlId="dataInicio">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group controlId="dataFim">
                                        <Form.Label>Data Fim</Form.Label>
                                        <Form.Control type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
                                    </Form.Group>
                                </Col>

                                {/* Oculta o select se props.un existir (página de unidade específica) */}
                                {!props.un && (
                                    <Col md={3}>
                                        <Form.Group controlId="filtroUnidade">
                                            <Form.Label>Unidade</Form.Label>
                                            <Form.Select value={unidadeSelecionada} onChange={(e) => setUnidadeSelecionada(e.target.value)}>
                                                <option value="">Todas as Unidades</option>
                                                {unidades.map((uni, index) => {
                                                    if (uni !== '') {
                                                        return <option key={index} value={index}>{uni}</option>
                                                    }
                                                    return null;
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                )}

                                <Col md={3}>
                                    <Form.Group controlId="filtroStatus">
                                        <Form.Label>Status de Entrega</Form.Label>
                                        <Form.Select value={statusEntrega} onChange={(e) => setStatusEntrega(e.target.value)}>
                                            <option value="todos">Todos os Pedidos</option>
                                            <option value="nao_entregues">Apenas Não Entregues</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex gap-2 justify-content-center align-items-center">
                                    <Button variant="primary" onClick={handlePesquisar}>Pesquisar</Button>
                                    <Button variant="success" onClick={handleExportCSV}>Exportar CSV</Button>
                                    <Button variant="warning" onClick={handleExportFotos}>Exportar Fotos</Button>
                                    <span className="ms-3 text-muted" style={{ fontSize: '0.9rem' }}>
                                        <strong>{processedData.length}</strong> alunos encontrados
                                    </span>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </center>

            <div className="table-responsive px-4" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <Table striped bordered hover size="sm" style={{ fontSize: '0.85rem' }}>
                    <thead className="table-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            {headerRow.map((header, index) => (
                                <th
                                    key={index}
                                    style={index === 6 ? { whiteSpace: 'nowrap' } : {}}
                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.length > 0 ? (
                            processedData.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                        <td
                                            key={cellIndex}
                                            style={cellIndex === 6 ? { whiteSpace: 'nowrap' } : {}}
                                        >
                                            {cell}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={headerRow.length} className="text-center py-4">
                                    Nenhum pedido encontrado para o filtro selecionado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}

export default Carteirinhas_pedidos;